<template>
  <div  class="whole-div-miq">
    <!--      第一行-->
    <div class="div1-miq">
        <div class="div1-div1-miq" @click="clickQuestion(item)" v-for="(item,index) in commonQuestionsList" :key="index">
          <!--          标题+时间-->
          <div class="div1-div1-div1-miq">
            <a class="div1-a1-miq">{{item.title}}</a>
            <a class="div1-a2-miq">发布时间:{{item.dateTime}}</a>
          </div>
          <!--          内容-->
          <div class="div1-div1-div2-miq">
            <a class="div1-a3-miq">{{item.details}}</a>
          </div>
          <!--          按钮：了解详情-->
          <div class="div1-div1-div3-miq">
            <div class="div1-div1-div3-div-miq">
              了解详情
            </div>
          </div>
        </div>
    </div>
    <!--    第2行-->
    <div class="div2-miq">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalPages">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import '../../css/mobile/MIQ_MobileIndustryQuestions.css'

  export default {
    name: "MobileIndustryQuestions",
    data() {
      return {//分页记录
        currentPage: 1,
        pageSize: 4,
        totalPages: 6,
        //行业新闻列表
        commonQuestionsList: [{
          title: '强化病死动物无害化处理监管',
          dateTime: '2024-05-17',
          details: '2月19日我部和国务院食品安全办、食品药品监管总局联合引发了《国务院食品安全办、农业部、国家食品药品监督管理总局关于进一步加强病死动物及其产品监管工作的通知》（食安办[2014]5号）（以下简称“通知”）。各地要认真贯彻落实“通知”精神，切实强化病死动物无害化处理监管工作。要采取有效措施督促落实动物养殖、屠宰等生产经营者主体责任。推动辖区内病死动物无害化处理场所所统筹规划、设施设备建设完善工作。上海、浙江、江苏、安徽、江西等水网密集省份要立即开展拉网式排查，坚决杜绝“黄浦江漂浮死猪”类似事件再次发生，要积极配合有关部门，强化执法检查，加强联防联控，严防病死动物产品流入市场和餐桌。',
        }, {
          title: '如何判断哪些畜禽和畜禽产品应当进行无害化处理',
          dateTime: '2024-05-17',
          details: '染疫或者疑似疫死亡、因病死亡或者死因不明的；经检疫、检验可能危害人体或者动物健康的；因自然灾害、应激反应、物理挤压等因素死亡的；屠宰过程中经肉品品质检验确认为不可食用的；死胎、木乃伊胎等；因动物疫病防控需要被扑杀或销毁的；其他应当进行无害化处理的。',
        }, {
          title: '对病害畜禽产品进行贮存和清运的要求',
          dateTime: '2024-05-17',
          details: '（一）采取必要的冷藏冷冻、清洗消毒等措施；\n' +
            '（二）具有病死畜禽和病害畜禽产品专用输出通道；\n' +
            '（三）及时通知病死畜禽无害化处理场进行收集，或自行送至指定地点。',
        }, {
          title: '畜禽无害化处理的详细说明',
          dateTime: '2024-05-17',
          details: '（一）病死畜禽和病害畜禽产品无害化处理以集中处理为主，自行处理为补充。\n' +
            '（二）畜禽养殖场、屠宰厂（场）、隔离场在本场（厂）内自行处理病死畜禽和病害畜禽产品的，应当符合无害化处理场所的动物防疫条件，不得处理本场（厂）外的病死畜禽和病害畜禽产品。\n' +
            '（三）对于边远和交通不便地区以及畜禽养殖户自行处理零星病死畜禽的，省级人民政府农业农村主管部门可以结合实际情况和风险评估结果，组织制定相关技术规范。\n' +
            '（四）鼓励在符合国家有关法律法规规定的情况下，对病死畜禽和病害畜禽产品无害化处理产物进行资源化利用。病死畜禽和病害畜禽产品无害化处理场所销售无害化处理产物的，应当严控无害化处理产物流向，查验购买方资质并留存相关材料，签订销售合同。\n' +
            '（五）病死畜禽和病害畜禽产品无害化处理应当符合安全生产、环境保护等相关法律法规和标准规范要求，接受有关主管部门监管。病死畜禽无害化处理场处理本办法第三条之外的病死动物和病害动物产品的，应当要求委托方提供无特殊风险物质的证明。',
        }],
        //行业新闻总列表
        commonQuestionsLists: [{
          title: '强化病死动物无害化处理监管',
          dateTime: '2024-05-17',
          details: '2月19日我部和国务院食品安全办、食品药品监管总局联合引发了《国务院食品安全办、农业部、国家食品药品监督管理总局关于进一步加强病死动物及其产品监管工作的通知》（食安办[2014]5号）（以下简称“通知”）。各地要认真贯彻落实“通知”精神，切实强化病死动物无害化处理监管工作。要采取有效措施督促落实动物养殖、屠宰等生产经营者主体责任。推动辖区内病死动物无害化处理场所所统筹规划、设施设备建设完善工作。上海、浙江、江苏、安徽、江西等水网密集省份要立即开展拉网式排查，坚决杜绝“黄浦江漂浮死猪”类似事件再次发生，要积极配合有关部门，强化执法检查，加强联防联控，严防病死动物产品流入市场和餐桌。',
        }, {
          title: '如何判断哪些畜禽和畜禽产品应当进行无害化处理',
          dateTime: '2024-05-17',
          details: '染疫或者疑似疫死亡、因病死亡或者死因不明的；经检疫、检验可能危害人体或者动物健康的；因自然灾害、应激反应、物理挤压等因素死亡的；屠宰过程中经肉品品质检验确认为不可食用的；死胎、木乃伊胎等；因动物疫病防控需要被扑杀或销毁的；其他应当进行无害化处理的。',
        }, {
          title: '对病害畜禽产品进行贮存和清运的要求',
          dateTime: '2024-05-17',
          details: '（一）采取必要的冷藏冷冻、清洗消毒等措施；\n' +
            '（二）具有病死畜禽和病害畜禽产品专用输出通道；\n' +
            '（三）及时通知病死畜禽无害化处理场进行收集，或自行送至指定地点。',
        }, {
          title: '畜禽无害化处理的详细说明',
          dateTime: '2024-05-17',
          details: '（一）病死畜禽和病害畜禽产品无害化处理以集中处理为主，自行处理为补充。\n' +
            '（二）畜禽养殖场、屠宰厂（场）、隔离场在本场（厂）内自行处理病死畜禽和病害畜禽产品的，应当符合无害化处理场所的动物防疫条件，不得处理本场（厂）外的病死畜禽和病害畜禽产品。\n' +
            '（三）对于边远和交通不便地区以及畜禽养殖户自行处理零星病死畜禽的，省级人民政府农业农村主管部门可以结合实际情况和风险评估结果，组织制定相关技术规范。\n' +
            '（四）鼓励在符合国家有关法律法规规定的情况下，对病死畜禽和病害畜禽产品无害化处理产物进行资源化利用。病死畜禽和病害畜禽产品无害化处理场所销售无害化处理产物的，应当严控无害化处理产物流向，查验购买方资质并留存相关材料，签订销售合同。\n' +
            '（五）病死畜禽和病害畜禽产品无害化处理应当符合安全生产、环境保护等相关法律法规和标准规范要求，接受有关主管部门监管。病死畜禽无害化处理场处理本办法第三条之外的病死动物和病害动物产品的，应当要求委托方提供无特殊风险物质的证明。',
        }, {
          title: '病死畜禽无害化的监督管理制度',
          dateTime: '2024-05-17',
          details: '（一）农业农村部建立病死畜禽无害化处理监管监控平台，加强全程追溯管理。从事畜禽饲养、屠宰、经营、隔离及病死畜禽收集、无害化处理的单位和个人，应当按要求填报信息。县级以上地方人民政府农业农村主管部门应当做好信息审核，加强数据运用和安全管理。\n' +
            '（二）农业农村部负责组织制定全国病死畜禽和病害畜禽产品无害化处理生物安全风险调查评估方案，对病死畜禽和病害畜禽产品收集、无害化处理生物安全风险因素进行调查评估。省级人民政府农业农村主管部门应当制定本行政区域病死畜禽和病害畜禽产品无害化处理生物安全风险调查评估方案并组织实施。\n' +
            '（三） 根据病死畜禽无害化处理场规模、设施装备状况、管理水平等因素，推行分级管理制度。\n' +
            '（四）从事畜禽饲养、屠宰、经营、隔离以及病死畜禽和病害畜禽产品收集、无害化处理的单位和个人，应当建立台账，详细记录病死畜禽和病害畜禽产品的种类、数量（重量）、来源、运输车辆、交接人员和交接时间、处理产物销售情况等信息。病死畜禽和病害畜禽产品处理场所应当安装视频监控设备，对病死畜禽和病害畜禽产品进（出）场、交接、处理和处理产物存放等进行全程监控。相关台账记录保存期不少于二年，相关监控影像资料保存期不少于三十天。',
        }, {
          title: '畜禽无害化的法律责任',
          dateTime: '2024-05-17',
          details: '（一）未按照相关规定处理病死畜禽和病害畜禽产品的，按照《动物防疫法》第九十八条规定予以处罚。\n' +
            '（二）畜禽养殖场、屠宰厂（场）、隔离场、病死畜禽无害化处理场未取得动物防疫条件合格证或生产经营条件发生变化，不再符合动物防疫条件继续从事无害化处理活动的，分别按照《动物防疫法》第九十八条、第九十九条处罚。\n' +
            '（三）专业从事病死畜禽和病害畜禽产品运输的车辆，未经备案或者不符合本办法第十四条规定的，分别按照《动物防疫法》第九十八条、第九十四条处罚。\n' +
            '（四）违反相关规定，未建立管理制度、台账或者进行视频监控的，由县级以上地方人民政府农业农村主管部门责令改正；拒不改正或者情节严重的，处二千元以上二万元以下罚款。',
        },]
      }
    },
    methods: {
      //问题点击
      clickQuestion(item){
        //赋值
        this.$store.state.questionIntroduce=item;
        // console.log(this.$store.state.questionIntroduce);
        this.$router.push({path:'/MobileQuestionIntroduce'});
      },
      //分页
      paginating(id) {
        let that = this;
        let leftPage = (id - 1) * that.pageSize;
        let rightPage = id * that.pageSize;
        // that.$store.state.MobileCommonQuestionsList=[];
        // for (let i = leftPage; i < rightPage; i++) {
        //   if (i < that.commonQuestionsLists.length) {
        //     that.$store.state.MobileCommonQuestionsList.push(that.commonQuestionsLists[i]);
        //   }
        // }
        that.commonQuestionsList=[];
        for (let i = leftPage; i < rightPage; i++) {
          if (i < that.commonQuestionsLists.length) {
            that.commonQuestionsList.push(that.commonQuestionsLists[i]);
          }
        }
      },
      //判断页面总数
      computedTotalPages(){
        let that=this;
        that.totalPages=that.commonQuestionsLists.length;
      },
      //点击分页按钮
      handleCurrentChange(val) {
        this.paginating(val);
        this.scrollToTop();
        console.log(`当前页: ${val}`);
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/mobile/second/MobileIndustryQuestions.vue